(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const hydrateVideoSources = (video) => {
      if (!video || video.dataset.mxSourcesReady === 'true') return false;
      let hydrated = false;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        if (!source.dataset.src) return;
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        hydrated = true;
      });

      if (video.dataset.src && !video.getAttribute('src')) {
        video.src = video.dataset.src;
        video.removeAttribute('data-src');
        hydrated = true;
      }

      video.dataset.mxSourcesReady = 'true';
      if (hydrated) video.load();
      return hydrated;
    };

    const revealItems = document.querySelectorAll('.mx-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    document.querySelectorAll('[data-mx-filter-group]').forEach((group) => {
      const buttons = group.querySelectorAll('[data-mx-filter]');
      const targetSelector = group.dataset.mxFilterTarget;
      const filterScope = group.closest('.mx-section') || document;
      const targets = filterScope.querySelectorAll(targetSelector);
      const companions = filterScope.querySelectorAll('[data-mx-filter-companion]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.mxFilter;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          targets.forEach((target) => {
            const categories = (target.dataset.mxCategories || '').split(' ');
            target.hidden = filter !== 'all' && !categories.includes(filter);
          });
          companions.forEach((companion) => {
            companion.hidden = filter !== 'all';
          });
        });
      });
    });

    document.querySelectorAll('[data-mx-accordion]').forEach((accordion) => {
      accordion.querySelectorAll('.mx-accordion__button').forEach((button) => {
        const panelId = button.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          panel.hidden = expanded;
        });
      });
    });

    document.querySelectorAll('[data-mx-video-shell]').forEach((shell) => {
      const button = shell.querySelector('[data-mx-video-play]');
      const video = shell.querySelector('[data-mx-lazy-video]');
      if (!button || !video) return;

      button.addEventListener('click', () => {
        document.querySelectorAll('[data-mx-lazy-video]').forEach((otherVideo) => {
          if (otherVideo !== video && !otherVideo.paused) otherVideo.pause();
        });

        hydrateVideoSources(video);
        video.hidden = false;
        shell.classList.add('is-active');
        const playback = video.play();
        if (playback) playback.catch(() => {});
      });
    });

    document.querySelectorAll('[data-mx-lazy-video]').forEach((video) => {
      if (video.closest('[data-mx-video-shell]')) {
        video.addEventListener('play', () => {
          document.querySelectorAll('[data-mx-lazy-video]').forEach((otherVideo) => {
            if (otherVideo !== video && !otherVideo.paused) otherVideo.pause();
          });
        });
        return;
      }

      const hydrate = () => hydrateVideoSources(video);
      video.addEventListener('pointerdown', hydrate, { once: true });
      video.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') hydrate();
      });

      video.addEventListener('play', () => {
        document.querySelectorAll('[data-mx-lazy-video]').forEach((otherVideo) => {
          if (otherVideo !== video && !otherVideo.paused) otherVideo.pause();
        });
      });
    });

    document.querySelectorAll('[data-mx-lazy-poster]').forEach((video) => {
      const loadPoster = () => {
        if (!video.dataset.posterSrc || video.poster) return;
        video.poster = video.dataset.posterSrc;
      };

      if ('IntersectionObserver' in window) {
        const posterObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadPoster();
            posterObserver.unobserve(entry.target);
          });
        }, { rootMargin: '600px 0px', threshold: 0.01 });
        posterObserver.observe(video);
      } else {
        loadPoster();
      }
    });

    document.querySelectorAll('[data-mx-deferred-autoplay]').forEach((video) => {
      const mobileQuery = window.matchMedia('(max-width: 767px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const saveData = Boolean(navigator.connection && navigator.connection.saveData);

      const playVideo = () => {
        if (reducedMotionQuery.matches || saveData) return;
        video.autoplay = true;
        const playback = video.play();
        if (playback) playback.catch(() => {});
      };

      if (mobileQuery.matches) {
        ['pointerdown', 'touchstart', 'keydown'].forEach((eventName) => {
          window.addEventListener(eventName, playVideo, { once: true, passive: eventName !== 'keydown' });
        });
      } else {
        playVideo();
      }
    });
  });
})();
